const { registerBlockType } = wp.blocks;
const { useEffect, useState } = wp.element;
const { InspectorControls } = wp.blockEditor;
const { ToggleControl } = wp.components;
const apiFetch = wp.apiFetch;

registerBlockType('ellis-marsalis/events-pull', {
    title: 'Events Pull',
    description: 'Pull the latest 4 events with featured images',
    category: 'ellis-marsalis',
    icon: 'calendar-alt',
    keywords: ['events', 'latest', 'featured images'],
    attributes: {
        alt_version: {
            type: 'boolean',
            default: false,
        },
    },
    edit: function (props) {
        const [events, setEvents] = useState([]);
        const { attributes, setAttributes } = props;
        const { alt_version } = attributes;

        useEffect(() => {
            const perPage = alt_version ? -1 : 4; // -1 to get all events for alt_version
            apiFetch({ path: `/wp/v2/mc-events?per_page=${perPage}&status=publish` })
                .then((data) => {
                    const filteredEvents = data.filter(event => event.featured_media);
                    setEvents(filteredEvents);
                });
        }, [alt_version]);

        const colors = ['#f3693f', '#3dafe4', '#7836b1', '#2F2852'];
        let i = 0;

        return (
            <>
                <InspectorControls>
                    <ToggleControl
                        label="Alt Version"
                        checked={alt_version}
                        onChange={(value) => setAttributes({ alt_version: value })}
                    />
                </InspectorControls>
                <div className="events-block">
                    {!alt_version && (
                        <div className="events-left">
                            <div className="events-left-top">
                                <h3>Upcoming Events</h3>
                                <img src="/wp-content/uploads/2023/08/EMC-students-RECITAL_20230420_399.jpg" alt="Upcoming Events" />
                            </div>
                            <div className="events-left-bottom">
                                <h3 className="event-big-live">Live</h3>
                                <h3 className="emcm">Ellis Marsalis Center</h3>
                                <a className="button" href="/calendar/">View the Full Calendar</a>
                            </div>
                        </div>
                    )}
                    <div className="events-grid">
                        {events.map((event) => {
                            const color = colors[i % colors.length];
                            i++;
                            return (
                                <div className="event" style={{ backgroundColor: color }} >
                                    <img src={event.uagb_featured_image_src.full[0]} alt={event.title.rendered} />
                                    <div className="event-info">
                                        <div className="event-date">
                                            <h6>SEP</h6>
                                            <h3>29</h3>
                                        </div>
                                        <div className="event-details">
                                            <h6>7:00pm – 8:30pm</h6>
                                            <h4>{event.title.rendered}</h4>
                                            <a className="button" href="#">Get Tickets</a>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </>
        );
    },
    save: function (props) {
        const { attributes } = props;
        const { alt_version } = attributes;

        return (
            <div className="wp-block-ellis-marsalis-events-pull events-grid" data-alt_version={alt_version.toString()}>
            </div>
        );
    },
});